//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ModalWithTitle from '~/components/Shared/ModalWithTitle'
import Button from '~/components/Shared/Button'
export default {
  components: {
    ModalWithTitle,
    Button,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isExpanded: false,
    }
  },
  mounted() {
    this.resize()
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
  },

  methods: {
    toogleModal() {
      this.$emit('toogle')
    },
    resize() {
      this.isExpanded = window.innerWidth <= 435
    },
  },
}
